<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2022-01-26 18:20:12
 * @LastEditTime: 2023-06-20 15:43:32
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
    <router-view  />
</template>

<script>
    export default {
        mounted(){
            // 监听路由，动态跳转
            window.addEventListener('hashchange',()=>{
                var currentPath = window.location.hash.slice(1); // 获取输入的路由
                if(this.$router.path !== currentPath){
                    this.$router.push(currentPath); // 动态跳转
                }
            },false);
        }
    }
</script>